/* Blog revamp (Oct 2026): category dropdowns, blog search suggestions, load-more feeds,
   mobile carousel, post table of contents, info tabs and FAQ accordion. Vanilla, no build step. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------ dropdowns */
  function initDropdowns() {
    var dds = qsa('.b26-dd');
    if (!dds.length) return;

    function closeAll(except) {
      dds.forEach(function (dd) {
        if (dd !== except) setOpen(dd, false);
      });
    }

    function setOpen(dd, open) {
      dd.classList.toggle('is-open', open);
      var btn = qs('.b26-pill', dd);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('b26-dd-open', open && MOBILE.matches);
    }

    dds.forEach(function (dd) {
      var btn = qs('.b26-pill', dd);
      var head = qs('.b26-dd__head', dd);
      var close = qs('.b26-dd__close', dd);
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !dd.classList.contains('is-open');
        closeAll(dd);
        setOpen(dd, open);
      });
      [head, close].forEach(function (el) {
        if (el) el.addEventListener('click', function () { setOpen(dd, false); });
      });
      if (close) dd.appendChild(close); // outside the scrolling panel so position: fixed holds
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.b26-dd')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ------------------------------------------------------------ blog search */
  // The pill-row search box: suggestions from predictive search while typing
  // (articles only), Enter / "See all results" goes to the results page.
  function initSearch(form) {
    var input = qs('.b26-search__input', form);
    var panel = qs('.b26-search__panel', form);
    var list = qs('.b26-search__list', form);
    var all = qs('.b26-search__all', form);
    var clear = qs('.b26-search__clear', form);
    if (!input || !panel || !list) return;
    var base = form.getAttribute('action') || '/search';
    var timer, ctrl, last = '';

    function resultsUrl(q) {
      return base + '?type=article&view=blog&q=' + encodeURIComponent(q);
    }

    function setOpen(open) {
      panel.hidden = !open;
      form.classList.toggle('is-open', open);
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function thumb(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
    }

    function render(items, q) {
      list.innerHTML = '';
      var none = qs('.b26-search__none', panel);
      if (none) none.parentNode.removeChild(none);
      items.forEach(function (a) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.href = a.url;
        link.setAttribute('role', 'option');
        if (a.image) {
          var img = document.createElement('img');
          img.src = thumb(a.image);
          img.alt = '';
          img.width = 48;
          img.height = 48;
          link.appendChild(img);
        }
        var span = document.createElement('span');
        span.textContent = a.title;
        link.appendChild(span);
        li.appendChild(link);
        list.appendChild(li);
      });
      if (!items.length) {
        var p = document.createElement('p');
        p.className = 'b26-search__none';
        p.textContent = 'No articles match “' + q + '”';
        panel.insertBefore(p, all);
      }
      if (all) {
        all.href = resultsUrl(q);
        all.textContent = items.length ? 'See all results for “' + q + '”' : 'Search anyway';
      }
      setOpen(true);
    }

    function suggest() {
      var q = input.value.trim();
      if (clear) clear.hidden = !q;
      if (q.length < 2) { setOpen(false); last = ''; return; }
      if (q === last) { if (list.children.length || qs('.b26-search__none', panel)) setOpen(true); return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = base + '/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=article&resources[limit]=5&resources[options][fields]=title,body,tag';
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (json) {
          if (q !== input.value.trim()) return;
          var items = (json.resources && json.resources.results && json.resources.results.articles) || [];
          render(items.map(function (a) { return { title: a.title, url: a.url, image: a.image }; }), q);
        })
        .catch(function () {});
    }

    function moveFocus(dir) {
      var links = qsa('a', panel);
      if (!links.length) return;
      var idx = links.indexOf(document.activeElement);
      var next = idx + dir;
      if (next < 0) { input.focus(); return; }
      if (next >= links.length) next = links.length - 1;
      links[next].focus();
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(suggest, 180);
    });
    input.addEventListener('focus', function () {
      form.classList.add('is-focused');
      if (input.value.trim().length >= 2 && input.value.trim() === last) setOpen(true);
    });
    input.addEventListener('blur', function () { form.classList.remove('is-focused'); });
    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      last = '';
      list.innerHTML = '';
      setOpen(false);
      input.focus();
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setOpen(false); input.focus(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) suggest(); else moveFocus(1); }
      else if (e.key === 'ArrowUp' && e.target !== input) { e.preventDefault(); moveFocus(-1); }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) setOpen(false);
    });
    if (clear) clear.hidden = !input.value;
  }

  /* ------------------------------------------------------------ feeds */
  function fetchCards(url) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'section_id=blog-26-cards', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = qs('.b26-cards', doc);
        return {
          cards: wrap ? qsa('.b26-card', wrap) : [],
          next: wrap ? wrap.getAttribute('data-next') : ''
        };
      });
  }

  function setVariant(card, variant) {
    card.className = card.className.replace(/\bb26-card--\w+/g, '').trim() + ' b26-card--' + variant;
  }

  // A feed fills itself from a tag page (data-feed) and reveals data-show cards at a time.
  function initFeed(feed) {
    var url = feed.getAttribute('data-feed');
    var show = parseInt(feed.getAttribute('data-show') || '3', 10);
    var variant = feed.getAttribute('data-variant') || 'grid';
    var mobileVariant = feed.getAttribute('data-variant-mobile') || variant;
    var exclude = feed.getAttribute('data-exclude') || '';
    var section = feed.closest('[data-feed-section]') || feed.parentNode;
    var more = qs('.b26-more', section);
    var moreBtn = more ? qs('[data-more]', more) : null;
    var next = url;
    var loading = false;
    // Server-rendered cards already fill the first row; later loads stay behind "More".
    var autoReveal = !qsa('.b26-card', feed).length;

    function applyVariant() {
      var v = MOBILE.matches ? mobileVariant : variant;
      qsa('.b26-card', feed).forEach(function (c) { setVariant(c, v); });
    }

    function revealSome() {
      var hidden = qsa('.b26-card[hidden]', feed);
      hidden.slice(0, show).forEach(function (c) { c.removeAttribute('hidden'); });
      updateMore();
    }

    function updateMore() {
      if (!more) return;
      var hasHidden = qsa('.b26-card[hidden]', feed).length > 0;
      more.hidden = !(hasHidden || next);
      if (moreBtn) moreBtn.disabled = loading;
    }

    function load() {
      if (!next || loading) return Promise.resolve();
      loading = true; updateMore();
      var target = next; next = '';
      return fetchCards(target).then(function (res) {
        var present = {};
        qsa('.b26-card', feed).forEach(function (c) { present[c.getAttribute('data-id')] = true; });
        res.cards.forEach(function (c) {
          var id = c.getAttribute('data-id');
          if ((exclude && id === exclude) || present[id]) return;
          present[id] = true;
          c.setAttribute('hidden', '');
          feed.appendChild(c);
        });
        next = res.next || '';
        applyVariant();
      }).catch(function () { next = ''; }).then(function () {
        loading = false;
        if (autoReveal) revealSome(); else updateMore();
        autoReveal = false;
        if (!qsa('.b26-card', feed).length) section.hidden = true;
        feed.dispatchEvent(new CustomEvent('b26:loaded'));
      });
    }

    if (moreBtn) moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (qsa('.b26-card[hidden]', feed).length) revealSome(); else load();
    });

    MOBILE.addEventListener ? MOBILE.addEventListener('change', applyVariant) : MOBILE.addListener(applyVariant);
    applyVariant();
    if (qsa('.b26-card', feed).length) { if (more) more.hidden = false; feed.dispatchEvent(new CustomEvent('b26:loaded')); }
    load();
  }

  // Server-rendered listing (category / all): "More" fetches the next page.
  function initListing(list) {
    var more = qs('.b26-more', list.parentNode);
    var btn = more ? qs('[data-more]', more) : null;
    var next = list.getAttribute('data-next') || '';
    if (!btn) return;
    more.hidden = !next;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!next) return;
      btn.disabled = true;
      fetchCards(next).then(function (res) {
        res.cards.forEach(function (c) { setVariant(c, 'grid'); list.appendChild(c); });
        next = res.next || '';
        if (next) btn.setAttribute('href', next);
      }).catch(function () { next = ''; }).then(function () {
        btn.disabled = false;
        more.hidden = !next;
      });
    });
  }

  /* ------------------------------------------------------------ mobile carousel dots */
  function initCarousel(feed) {
    var dots = qs('.b26-dots', feed.parentNode);
    if (!dots) return;

    function render() {
      var cards = qsa('.b26-card:not([hidden])', feed);
      dots.innerHTML = '';
      cards.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });
      dots.hidden = cards.length < 2;
    }

    function update() {
      var cards = qsa('.b26-card:not([hidden])', feed);
      if (!cards.length) return;
      var mid = feed.scrollLeft + feed.clientWidth / 2;
      var idx = 0;
      cards.forEach(function (c, i) {
        if (c.offsetLeft <= mid) idx = i;
      });
      qsa('span', dots).forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    }

    feed.addEventListener('b26:loaded', render);
    feed.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    render();
  }

  /* ------------------------------------------------------------ post: table of contents */
  function slug(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }

  function initToc(toc) {
    var content = qs('.b26-post__content');
    var list = qs('.b26-toc__list', toc);
    if (!content || !list) return;

    var headings = qsa('h2', content).filter(function (h) { return h.textContent.trim(); });
    var used = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slug(h.textContent), id = base, n = 2;
        while (document.getElementById(id) || used[id]) { id = base + '-' + n++; }
        h.id = id;
      }
      used[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    var faq = qs('#b26-faq');
    if (faq) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#b26-faq';
      a.textContent = 'Frequently Asked Questions';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        activateTab('faq');
        var box = qs('.b26-tabs');
        if (box) window.scrollTo(0, box.getBoundingClientRect().top + window.scrollY - 90); // html has scroll-behavior: smooth
      });
      li.appendChild(a);
      list.appendChild(li);
    }

    if (!list.children.length) {
      // Fall back to the hand-written anchor list some older posts carry.
      var legacy = qs('.b26-toc__legacy', toc);
      if (legacy && legacy.innerHTML.trim()) {
        list.innerHTML = legacy.innerHTML;
      } else {
        toc.hidden = true;
        return;
      }
    }

    var toggle = qs('.b26-toc__toggle', toc);
    if (MOBILE.matches) toc.classList.add('is-collapsed');
    toggle.addEventListener('click', function () {
      var collapsed = toc.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });

    // Highlight the heading currently in view.
    if ('IntersectionObserver' in window && headings.length) {
      var links = qsa('a', list);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) { l.classList.toggle('is-current', l.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      headings.forEach(function (h) { io.observe(h); });
    }
  }

  /* ------------------------------------------------------------ post: tabs + faq */
  function activateTab(name) {
    var tabs = qs('.b26-tabs');
    if (!tabs) return;
    qsa('.b26-tabs__tab', tabs).forEach(function (t) {
      var on = t.getAttribute('data-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    qsa('.b26-tabs__panel', tabs).forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== name;
    });
  }

  function initTabs(tabs) {
    qsa('.b26-tabs__tab', tabs).forEach(function (t) {
      t.addEventListener('click', function () { activateTab(t.getAttribute('data-tab')); });
    });
    qsa('.b26-faq__q', tabs).forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = q.nextElementSibling;
        if (a) a.hidden = open;
      });
    });
    if (location.hash === '#b26-faq') activateTab('faq');
  }

  /* ------------------------------------------------------------ coming soon (empty category) */
  function initComingSoon() {
    var data = qs('#b26-categories');
    if (!data) return;
    var handle = (location.hash || '').replace('#', '');
    var cats;
    try { cats = JSON.parse(data.textContent); } catch (e) { return; }
    var cat = cats.filter(function (c) { return c.handle === handle; })[0];
    if (!cat) return;
    var title = qs('.b26-head__title');
    var intro = qs('.b26-head__intro');
    if (title) title.textContent = cat.title;
    if (intro) { intro.textContent = cat.intro || ''; intro.hidden = !cat.intro; }
    document.title = cat.title + ' | Novomins';
    var dd = qs('.b26-dd .b26-pill[data-group="' + cat.group + '"]');
    if (dd) {
      dd.closest('.b26-dd').classList.add('is-selected');
      var label = qs('.b26-pill__label', dd);
      if (label) label.textContent = cat.title;
      qsa('.b26-dd__panel a[data-cat="' + cat.handle + '"]').forEach(function (a) { a.classList.add('is-active'); });
    }
    var nav = qs('.b26-nav');
    if (nav) {
      nav.classList.add('b26-nav--category');
      // mobile: the (x) returns to the blog home, as on a normal category page
      var close = document.createElement('a');
      close.className = 'b26-nav__close';
      close.href = nav.getAttribute('data-home') || '/blogs/news';
      close.setAttribute('aria-label', 'Back to the blog home');
      close.innerHTML = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      nav.insertBefore(close, nav.firstChild);
      qsa('.b26-nav > .b26-pill, .b26-nav > div', nav).forEach(function (el) {
        var selected = el.classList.contains('is-selected') || !!qs('.is-selected', el);
        el.classList.toggle('b26-nav__secondary', !selected);
      });
    }
  }

  /* ------------------------------------------------------------ boot */
  // Shopify's theme-preview bar sits over the bottom of the viewport; lift fixed controls above it.
  function initBottomBar() {
    function measure() {
      var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = bar && bar.offsetHeight ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--b26-bottom-bar', h + 'px');
    }
    measure();
    window.setTimeout(measure, 1500);
    window.addEventListener('resize', measure);
  }

  function boot() {
    initBottomBar();
    initDropdowns();
    qsa('[data-search]').forEach(initSearch);
    qsa('[data-feed]').forEach(function (feed) {
      initFeed(feed);
      if (feed.classList.contains('b26-carousel')) initCarousel(feed);
    });
    qsa('.b26-listing__grid').forEach(initListing);
    var toc = qs('.b26-toc');
    if (toc) initToc(toc);
    var tabs = qs('.b26-tabs');
    if (tabs) initTabs(tabs);
    initComingSoon();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
